import styled from 'styled-components'

export const AmbassadorsWrapper = styled.div`
  padding: 29px 0 0 0;

  & > * {
    z-index: ${props => props.theme.zIndexes.cities.content};
  }

  &:after {
    content: '';
    position: fixed;
    width: 100%;
    height: 100%;
    background: ${props => props.theme.colors.white};
    left: 0;
    z-index: ${props => props.theme.zIndexes.cities.background};
  }
  .manage-onboarding-button {
    display: flex;
    margin-right: 40px;
    justify-content: flex-end;
    text-decoration: none;
  }
  .SearchAndFilters {
    margin-left: 40px;
  }

  .search-input {
    display: block;
    max-width: 285px;
    float: left;
  }

  .select-status {
    float: left;
    margin: 0 20px 0 0;

    div:nth-child(2) {
      width: 165px !important;
    }
  }

  .select-carrying {
    float: left;
    div:nth-child(2) {
      width: 145px !important;
    }
  }

  table {
    th {
      height: 70px;

      &:last-child {
        padding-right: 30px !important;
      }
    }
    td {
      &:last-child {
        padding-right: 30px !important;
      }
    }

    th:nth-child(1),
    td:nth-child(1) {
      padding-left: 40px;
    }

    .actions-cell {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    td {
      &:nth-child(6) {
        position: relative;

        .has-merchandise {
          position: absolute;
          left: 0;
          right: 0;
          width: 23px;
          margin: auto;
          top: 50%;
          transform: translateY(-50%);

          input {
            left: 0;
          }
        }
      }

      &:last-child {
        position: relative;

        a {
          display: inline-block;
          position: relative;
          margin: 0 6px 0 0;

          svg {
            margin-right: 0;
          }
        }
      }
    }
  }
`
